(() => {
  const nativeMainButtonSelector = '.main-product-form .atc-button.main-product-atc';
  const shiprocketButtonSelector = '.main-product-form .shiprocket-headless[data-type="product"] .sr-headless-checkout';
  const stickyButtonContainerSelector = '.sticky-atc .sticky-atc__button';

  let updateQueued = false;

  function hideNativeAddToCart() {
    const nativeButton = document.querySelector(nativeMainButtonSelector);
    const nativeButtonRow = nativeButton && nativeButton.closest('.product-form__quantity-and-btn');

    if (nativeButtonRow) nativeButtonRow.classList.add('sheverse-native-atc-hidden');
  }

  function mountStickyBuyNow() {
    const sourceButton = document.querySelector(shiprocketButtonSelector);
    const stickyButtonContainer = document.querySelector(stickyButtonContainerSelector);

    if (!sourceButton || !stickyButtonContainer) return;

    let stickyWrapper = stickyButtonContainer.querySelector('.sheverse-sticky-buy-now');
    let stickyButton = stickyWrapper && stickyWrapper.querySelector('.sr-headless-checkout');

    if (!stickyWrapper) {
      stickyWrapper = document.createElement('div');
      stickyWrapper.className = 'shiprocket-headless sheverse-sticky-buy-now';
      stickyButtonContainer.appendChild(stickyWrapper);
    }

    if (!stickyButton) {
      stickyButton = sourceButton.cloneNode(true);
      stickyButton.removeAttribute('onclick');
      stickyButton.removeAttribute('name');
      stickyButton.setAttribute('aria-label', 'Buy now');
      stickyButton.addEventListener('click', () => {
        const currentSourceButton = document.querySelector(shiprocketButtonSelector);
        if (currentSourceButton && !currentSourceButton.disabled) currentSourceButton.click();
      });
      stickyWrapper.appendChild(stickyButton);
    }

    if (stickyButton.innerHTML !== sourceButton.innerHTML) {
      stickyButton.innerHTML = sourceButton.innerHTML;
    }

    stickyButton.disabled = sourceButton.disabled;
    stickyButton.setAttribute('aria-disabled', String(sourceButton.disabled));

    const stickyBar = stickyButtonContainer.closest('.sticky-atc');
    if (stickyBar) stickyBar.classList.add('sheverse-sticky-buy-now-managed');
  }

  function updateStickyVisibility() {
    const sourceButton = document.querySelector(shiprocketButtonSelector);
    const stickyBar = document.querySelector('.sticky-atc.sheverse-sticky-buy-now-managed');

    if (!sourceButton || !stickyBar) return;

    const sourceRect = sourceButton.getBoundingClientRect();
    stickyBar.classList.toggle('sheverse-sticky-buy-now-visible', sourceRect.bottom < 0);
  }

  function updateButtons() {
    updateQueued = false;
    hideNativeAddToCart();
    mountStickyBuyNow();
    updateStickyVisibility();
  }

  function queueUpdate() {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(updateButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueUpdate, { once: true });
  } else {
    queueUpdate();
  }

  const observer = new MutationObserver(queueUpdate);
  const mutationRoot = document.querySelector('.main-product-form') || document.documentElement;
  observer.observe(mutationRoot, { childList: true, subtree: true });

  window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  window.addEventListener('resize', updateStickyVisibility);
})();
